// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fq","advertDetailContactGroup__header":"c-n_fr","advertDetailContactGroup__value":"c-n_fs"};